import './bootstrap';
import docs from './docs';

window.addEventListener('load', docs);
